import { useContext } from "react";
import { ContentsContext } from "../context/contents.contexts";

export const useContentsContext = () => {
  return useContext(ContentsContext);
};
